export function getProgressPercent({ processed = 0, total = 0 }) {
  if (total > 0) {
    return Math.min(100, Math.round((processed / total) * 100));
  }
  if (processed > 0) {
    return 100;
  }
  return 5;
}

export function initBatchProgress(setProgress, { title, total }) {
  setProgress({
    title,
    processed: 0,
    total,
    success: 0,
    failed: 0,
  });
}

export function tickBatchProgress(setProgress, { success = false, failed = false } = {}) {
  setProgress((prev) =>
    prev
      ? {
          ...prev,
          processed: prev.processed + 1,
          success: prev.success + (success ? 1 : 0),
          failed: prev.failed + (failed ? 1 : 0),
        }
      : null
  );
}

export function clearBatchProgress(setProgress) {
  setProgress(null);
}

export async function runWithProgress(setProgress, { title, total, run }) {
  initBatchProgress(setProgress, { title, total });
  try {
    return await run((result = {}) => tickBatchProgress(setProgress, result));
  } finally {
    clearBatchProgress(setProgress);
  }
}
